import { Polyline } from "@react-google-maps/api";
import { ColorSpectrum } from "types/ColorSpectrum";

interface RouteMarkerProps {
  points: { lat: number; lng: number }[];
  color?: ColorSpectrum;
  highlight?: boolean;
  isReturn?: boolean;
  tooltip?: string;
  onClick?: (e?: any) => void;
}
export default function RoutePath({
  points,
  color,
  highlight,
  isReturn,
  onClick,
}: RouteMarkerProps) {
  const lineSymbol = {
    path: "M 0,0 0,0",
    strokeOpacity: 1,
    scale: 5,
    strokeColor: color?.dark40,
  };
  return isReturn ? (
    <>
      <Polyline
        path={points}
        onClick={onClick}
        options={{
          icons: [
            {
              icon: lineSymbol,
              offset: "0",
              repeat: "10px",
            },
          ],
          strokeColor: highlight ? color?.dark40 : color?.main,
          strokeOpacity: 1,
          strokeWeight: 5,
        }}
      />
    </>
  ) : (
    <>
      <Polyline
        path={points}
        onClick={onClick}
        options={{
          strokeColor: color?.dark40,
          strokeOpacity: 1,
          strokeWeight: 8,
          zIndex: highlight ? 99999 : undefined,
        }}
      />
      <Polyline
        onClick={onClick}
        path={points}
        options={{
          strokeColor: highlight ? color?.dark40 : color?.main,
          strokeOpacity: 1,
          strokeWeight: 5,
        }}
      />
    </>
  );
}
